import { useEffect, useRef } from 'react';

export default function FadeInSection({ children, direction = 'up', delay = 0, className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('fis-visible');
          obs.disconnect(); // animate once, then stop watching
        }
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px 0px 0px',
      }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`fis fis-${direction}${className ? ` ${className}` : ''}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
